import { createMuiTheme } from 'material-ui/styles';
import teal from 'material-ui/colors/teal';

export default createMuiTheme({

  palette: {
    type: 'light',
    primary: teal
  },

  qborder: {

    drawer: {
      width: '240px'
    }

  },

  overrides: {

    MuiTooltip: {
      tooltipBottom: {
        margin: '0 !important'
      }
    },

    MuiDrawer: {
      paper: {
        zIndex: 1050
      }
    },

    MuiFormControl: {
      root: {
        width: '100%',
        marginBottom: '16px'
      }
    },

    MuiSelect: {
      root: {
        textAlign: 'left'
      }
    }

  }

});





// WEBPACK FOOTER //
// ./src/themes/light.js